import { jsx as t } from "react/jsx-runtime";
import { SectionAutoComplete as i } from "./index.es564.js";
import { BaseAutoComplete as p } from "./index.es565.js";
const n = "auto-complete-component", l = ({
  testId: e = n,
  ...o
}) => {
  var m;
  return (m = o.menuType) != null && m.includes("sectioned") ? /* @__PURE__ */ t(
    i,
    {
      ...o,
      testId: e,
      items: o.items
    }
  ) : /* @__PURE__ */ t(p, { ...o, testId: e, items: o.items });
};
export {
  n as AUTOCOMPLETE_DEFAULT_TESTID,
  l as AutoComplete
};
//# sourceMappingURL=index.es2.js.map
